import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { CompanyProfileApiService } from 'src/services/companyProfileApi'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'

export const useGetCompanyProfileQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId,
    queryFn: () => CompanyProfileApiService.get(),
    queryKey: [QueryKey.GET_COMPANY_PROFILE],
  })
}
